//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import { lockBody, unlockBody } from "./helpers/body-lock-toggle";

window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    let mediaSplidePanel = document.querySelectorAll('.media-panel');
    let newsSplidePanel = document.querySelectorAll('.news-page-wrapper');

    if (availableCarousels.length) {

        // START MEDIA PANEL SLIDER
        for ( let panel of mediaSplidePanel ) {
            let parentPanel = panel.closest('.media-panel');
            let totalSlides = parentPanel.querySelector('.media-splide').dataset.totalSlides;
            let currentPostCounter = parentPanel.querySelector('[data-splide="counter"]');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            let mediaSplide = new Splide(panel.querySelector('.media-splide'), {
                type: 'fade',
                speed: 750,
                arrows: false,
                autoplay: false,
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        mediaSplide.go('+1');
                    }
                    else {
                        mediaSplide.go('-1');
                    }
                });
            }

            mediaSplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        currentPostCounter.textContent = (mediaSplide.index + 1);

                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (mediaSplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }

                            if (arrow.dataset.navigate == '-' && (mediaSplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }
                        }
                    }, 50);
                }
            });

            mediaSplide.mount()
        }
        // END MEDIA PANEL SLIDER

        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            let parentPanel = panel.closest('.gallery-panel');
            let galleryThumbnails = parentPanel.querySelectorAll('.gallery-panel-image');
            let lightbox = parentPanel.querySelector('.gallery-panel-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);

            let lbox = new Splide(panel.querySelector('.gallery-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 rounded-l-lg w-14 h-16 p-2 bg-white bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
                unlockBody();
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
                lockBody();
            }


            // Closes lightbox on backdrop/close button press

            lightboxBackdrop.addEventListener('click', () => {
                closeLightBox();
            });

            lightboxClose.addEventListener('click', () => {
                closeLightBox();
            });

            // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

            document.addEventListener("keydown", (e) => {
                if (!lightbox.classList.contains('hidden')) {
                    if (e.key === "Escape") {
                        closeLightBox();
                    }
                    else if (e.key === "ArrowRight") {
                        lbox.go('+1');
                    }
                    else if (e.key === "ArrowLeft") {
                        lbox.go('-1');
                    }
                }
            });

            // Opens lightbox and navigates carousel to the thumbnail that was pressed

            for ( let thumbnail of galleryThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        lbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            // Updates carousel progress bar width

            lbox.on('mounted move', function () {
                let end = lbox.Components.Controller.getEnd() + 1;
                progressBar.style.width = String(100 * (lbox.index + 1) / end) + '%';
            });

            lbox.mount();
        }
        // END GALLERY PANEL SLIDER

        // START NEWS GALLERY SLIDER
        for ( let panel of newsSplidePanel ) {
            let parentPanel = panel.closest('.news-page-wrapper');
            let galleryThumbnails = parentPanel.querySelectorAll('.open-lightbox');
            let lightbox = parentPanel.querySelector('.news-page-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);

            let newsLbox = new Splide(panel.querySelector('.news-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 rounded-l-lg w-14 h-16 p-2 bg-white bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
                unlockBody();
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
                lockBody();
            }


            // Closes lightbox on backdrop/close button press

            lightboxBackdrop.addEventListener('click', () => {
                closeLightBox();
            });

            lightboxClose.addEventListener('click', () => {
                closeLightBox();
            });

            // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

            document.addEventListener("keydown", (e) => {
                if (!lightbox.classList.contains('hidden')) {
                    if (e.key === "Escape") {
                        closeLightBox();
                    }
                    else if (e.key === "ArrowRight") {
                        newsLbox.go('+1');
                    }
                    else if (e.key === "ArrowLeft") {
                        newsLbox.go('-1');
                    }
                }
            });

            // Opens lightbox and navigates carousel to the thumbnail that was pressed

            for ( let thumbnail of galleryThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        newsLbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            // Updates carousel progress bar width

            newsLbox.on('mounted move', function () {
                let end = newsLbox.Components.Controller.getEnd() + 1;
                progressBar.style.width = String(100 * (newsLbox.index + 1) / end) + '%';
            });

            newsLbox.mount();
        }
        // END NEWS GALLERY SLIDER
    }
});
